import { nextPeriod, type Period } from '@finbob/shared';
import type { MonthSummaryRow } from '../api';

/**
 * The month Home opens on: the current period, unless it is already closed — then the first
 * later period that is still open or not yet opened, so finishing a month moves Home forward.
 */
export function homePeriod(current: Period, months: readonly MonthSummaryRow[]): Period {
  const closed = new Set(months.filter((m) => m.status === 'closed').map((m) => m.period));
  let period = current;
  while (closed.has(period)) period = nextPeriod(period);
  return period;
}
